export default {
		name: 'users',
		data() {
			return {
				Shop: [],
				userType: [],
				userStae: [{
					id: '0',
					text: '正常'
				}, {
					id: '1',
					text: '停用'
				}],
				users: '',
				Edit: '',
				getData: {},
				clear: {},
				ShopID: this.$store.state.user.ShopID,
				UserAccount: '',
				UserPassWorld: '',
				UserPhone: '',
				UserName: '',
				UserType: 2,
				UserState: 0,
				UserID: 0,
				areaID: this.$store.state.user.areaID
			};
		},
		created() {
			this.areaID = this.$store.state.user.areaID;

			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);

			this.userType = [{
				id: 0,
				text: '管理员'
			}, {
				id: 1,
				text: '店长'
			}, {
				id: 2,
				text: '店员'
			}, {
				id: 3,
				text: '派送员'
			}];
			this.getData = function() {
				this.$request.request({
					url: 'login/getUsers',
					data: {
						pageCount: -1,
						ShopID: this.ShopID,
						UserState: this.UserState
					},
					method: 'post'
				}).then(res => {
					if (res.result)
						this.users = res.users;
				});
			}
			this.clear = function() {
				this.UserAccount = '';
				this.UserPassWorld = '';
				this.UserName = '';
				this.UserType = 2;
				this.UserPhone = "";
				//this.UserState = 0;
				this.UserID = 0;
			}
			this.getData();

		},
		methods: {
			selectArea() {
				 
				this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
				 
				this.count = 0;
				 
			
				if (this.Shop.length > 0) {
					this.ShopID = this.Shop[0].ShopID;
					this.pageIndex = 1;
					this.getData();
				}
			},
			cancel() {
				this.Edit = '';
				this.clear();
			},
			editUsers() {
				this.Edit = '';
				this.$request.request({
					url: 'login/editUser',
					data: {
						ShopID: this.ShopID,
						UserAccount: this.UserAccount,
						UserPassWorld: this.UserPassWorld,
						UserName: this.UserName,
						UserType: this.UserType,
						UserPhone: this.UserPhone,
						UserState: this.UserState,
						UserID: this.UserID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.$uil.showMessage({
							text: res.message
						});
						this.clear();
						this.getData();
					}
				});


			},
			updateUsers(i) {
				this.Edit = 'update';
				this.UserID = i.UserID;
				this.ShopID = i.ShopID;
				this.UserAccount = i.UserAccount;
				this.UserPassWorld = i.UserPassWorld;
				this.UserName = i.UserName;
				this.UserType = i.UserType;
				this.UserState = i.UserState;
				this.UserPhone = i.UserPhone;
			}
		},
		computed: {
			checkUser() {

				return this.$uil.checkchinese(this.UserName, 2, 5) && this.$uil.checkstr(this.UserPassWorld, 6, 16) && this
					.$uil.checkstr(
						this.UserAccount, 6, 16) && this.$uil.checkPhone(this.UserPhone);
			}

		},
		filters: {
			UserType(v) {
				if (v == '0') return '管理员';
				if (v == '1') return '店长';
				if (v == '2') return '店员';
				if (v == '3') return '派送员';
			},
			UserState(v) {
				if (v == '0') return '正常';
				if (v == '1') return '停用';

			}
		},
		activated() {

		}

	}